import { render, staticRenderFns } from "./SurveyRevisionComments.vue?vue&type=template&id=75f5f871&"
import script from "./SurveyRevisionComments.vue?vue&type=script&lang=js&"
export * from "./SurveyRevisionComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports